export default "__VITE_ASSET__DRRb$SQI__"